import { motion } from "framer-motion";

function Experience() {
  const clients = [
    "client1.png",
    "client2.png",
    "client3.png",
    "client4.png",
    "client5.png",
    "client6.png",
    "client7.png",
    "client8.png",
    "client9.png"
  ];

  return (
    <motion.div 
      className="experience" 
      id="experience"
      initial={{ opacity: 0, y: 75 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <h2 className="main-title text-center">EXPERIENCE</h2>
        
        {/* Map Section */}
        <div className="map-section">
          <div className="map-legend">
            <h3>Global Operations</h3>
            <p>Our footprint across EMEA & APAC regions.</p>
            <ul className="legend-list">
              <li><span className="dot-indicator" style={{backgroundColor: "#eeff00ff"}}></span> ROV Burial</li>
              <li><span className="dot-indicator" style={{backgroundColor: "#ff0000ff"}}></span> Subsea Cable Installation</li>
              <li><span className="dot-indicator" style={{backgroundColor: "#000000ff"}}></span> Plough Trenching</li>
              <li><span className="dot-indicator" style={{backgroundColor: "#33FF57"}}></span> Repair Cable</li>
              <li><span className="dot-indicator" style={{backgroundColor: "#b300ffff"}}></span> Data Processing</li>
            </ul>
          </div>
          <div className="map-visual">
            <img loading="lazy" src={process.env.PUBLIC_URL + "/img/world-map.png"} alt="World Map" className="world-map-img" />
            
            {/* ROV Burial */}
            <div className="map-dot" style={{top: '33%', left: '21%', backgroundColor: '#eeff00ff', animationDelay: '0s'}}>
                {/* <span className="tooltip">Italy</span> */}
            </div>
            <div className="map-dot" style={{top: '48%', left: '57%', backgroundColor: '#eeff00ff', animationDelay: '1s'}}>
                {/* <span className="tooltip">Myanmar</span> */}
            </div>
            <div className="map-dot" style={{top: '60%', left: '64%', backgroundColor: '#eeff00ff', animationDelay: '1s'}}>
                {/* <span className="tooltip">1</span> */}
            </div>
            <div className="map-dot" style={{top: '64%', left: '69%', backgroundColor: '#eeff00ff', animationDelay: '1s'}}>
                {/* <span className="tooltip">2</span> */}
            </div>
            <div className="map-dot" style={{top: '51%', left: '73%', backgroundColor: '#eeff00ff', animationDelay: '1s'}}>
                {/* <span className="tooltip">3</span> */}
            </div>
            
            {/* Subsea Cable Installation */}
            <div className="map-dot" style={{top: '80%', left: '19%', backgroundColor: '#ff0000ff', animationDelay: '0.5s'}}>
                {/* <span className="tooltip">Namibia</span> */}
            </div>
            <div className="map-dot" style={{top: '44%', left: '30%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">Egypt</span> */}
            </div>
                        <div className="map-dot" style={{top: '58%', left: '40%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">3</span> */}
            </div>
                        <div className="map-dot" style={{top: '55%', left: '48%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">4</span> */}
            </div>
                        <div className="map-dot" style={{top: '53%', left: '60%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">5</span> */}
            </div>
                        <div className="map-dot" style={{top: '56%', left: '62%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">6</span> */}
            </div>
                        <div className="map-dot" style={{top: '67%', left: '68%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">7</span> */}
            </div>
                        <div className="map-dot" style={{top: '48%', left: '73%', backgroundColor: '#ff0000ff', animationDelay: '1.5s'}}>
                {/* <span className="tooltip">8</span> */}
            </div>


             {/* Plough Trenching */}
             <div className="map-dot" style={{top: '49%', left: '59%', backgroundColor: '#000000ff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">1</span> */}
            </div>
            <div className="map-dot" style={{top: '64%', left: '67%', backgroundColor: '#000000ff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">2</span> */}
            </div>
            <div className="map-dot" style={{top: '57%', left: '63%', backgroundColor: '#000000ff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">3</span> */}
            </div>
            <div className="map-dot" style={{top: '50%', left: '75%', backgroundColor: '#000000ff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">4</span> */}
            </div>
            <div className="map-dot" style={{top: '17%', left: '87%', backgroundColor: '#000000ff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">5</span> */}
            </div>

            {/* Data Processing */}
            <div className="map-dot" style={{top: '17%', left: '89%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">1</span> */}
            </div>
            <div className="map-dot" style={{top: '47%', left: '75%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">2</span> */}
            </div>
            <div className="map-dot" style={{top: '67%', left: '70%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">3</span> */}
            </div>
            <div className="map-dot" style={{top: '57%', left: '65%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">4</span> */}
            </div>
            <div className="map-dot" style={{top: '50%', left: '56%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">5</span> */}
            </div>
            <div className="map-dot" style={{top: '57%', left: '49%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">6</span> */}
            </div>
            <div className="map-dot" style={{top: '60%', left: '38%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">7</span> */}
            </div>
            <div className="map-dot" style={{top: '47%', left: '32%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">Saudi Arabia</span> */}
            </div>
            <div className="map-dot" style={{top: '83%', left: '20%', backgroundColor: '#b300ffff', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">Namibia</span> */}
            </div>

            { /* Repair Cable */}
            <div className="map-dot" style={{top: '51%', left: '58%', backgroundColor: '#33FF57', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">1</span> */}
            </div>
            <div className="map-dot" style={{top: '59%', left: '63%', backgroundColor: '#33FF57', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">2</span> */}
            </div>
            <div className="map-dot" style={{top: '66%', left: '66%', backgroundColor: '#33FF57', animationDelay: '0.2s'}}>
                {/* <span className="tooltip">3</span> */}
            </div>
          </div>
        </div>

        

        <p className="main-p text-center">
            Trusted by industry leaders worldwide.
        </p>
        <div className="carousel-container">
          <div className="carousel-track">
            {clients.map((client, index) => (
              <div className="carousel-item" key={index}>
                <img 
                  loading="lazy"
                  src={process.env.PUBLIC_URL + "/img/clients/" + client} 
                  alt={`Client ${index + 1}`} 
                />
              </div>
            ))}
             {/* Duplicate for seamless infinite scroll */}
             {clients.map((client, index) => (
              <div className="carousel-item" key={`dup-${index}`}>
                <img 
                  loading="lazy"
                  src={process.env.PUBLIC_URL + "/img/clients/" + client} 
                  alt={`Client ${index + 1}`} 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Experience;